import * as UI from "@iyk/music-ui"

export const Meta = UI.Meta.withDefaults({
  title: "IYK Music",
  description:
    "Showcase your fandom — turn real-world actions into rewards. Check in to shows, upload clips, claim items, and your build your collection.",
  image: "https://assets.iyk.app/music/iyk-music-og.jpg",
  url: "https://iyk.app/music",
  domain: "iyk.app"
})
